export class CreateSapSourceInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "agentId",
            "baseName": "agentId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "shortName",
            "baseName": "shortName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sid",
            "baseName": "sid",
            "type": "string",
            "format": ""
        },
        {
            "name": "client",
            "baseName": "client",
            "type": "string",
            "format": ""
        },
        {
            "name": "host",
            "baseName": "host",
            "type": "string",
            "format": ""
        },
        {
            "name": "systemNumber",
            "baseName": "systemNumber",
            "type": "string",
            "format": ""
        },
        {
            "name": "sapUser",
            "baseName": "sapUser",
            "type": "string",
            "format": ""
        },
        {
            "name": "release",
            "baseName": "release",
            "type": "string",
            "format": ""
        },
        {
            "name": "glueDatabase",
            "baseName": "glueDatabase",
            "type": "string",
            "format": ""
        },
        {
            "name": "deploymentShape",
            "baseName": "deploymentShape",
            "type": "SapDeploymentShape",
            "format": ""
        },
        {
            "name": "privateLinkVariant",
            "baseName": "privateLinkVariant",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkState",
            "baseName": "privateLinkState",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkEndpointDns",
            "baseName": "privateLinkEndpointDns",
            "type": "string",
            "format": ""
        },
        {
            "name": "privateLinkAccepted",
            "baseName": "privateLinkAccepted",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "selectedObjects",
            "baseName": "selectedObjects",
            "type": "Array<SapObjectSelection>",
            "format": ""
        },
        {
            "name": "scheduleStart",
            "baseName": "scheduleStart",
            "type": "SapScheduleStart",
            "format": ""
        },
        {
            "name": "cdcPollingSeconds",
            "baseName": "cdcPollingSeconds",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertCdcLagMinutes",
            "baseName": "alertCdcLagMinutes",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertErrorRatePct",
            "baseName": "alertErrorRatePct",
            "type": "number",
            "format": ""
        },
        {
            "name": "alertAgentOfflineMinutes",
            "baseName": "alertAgentOfflineMinutes",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateSapSourceInput.attributeTypeMap;
    }
    constructor() {
    }
}
